import { render, staticRenderFns } from "./TaskFreeWritingView.vue?vue&type=template&id=95ae2d0c&scoped=true&"
import script from "./TaskFreeWritingView.vue?vue&type=script&lang=ts&"
export * from "./TaskFreeWritingView.vue?vue&type=script&lang=ts&"
import style0 from "./TaskFreeWritingView.vue?vue&type=style&index=0&id=95ae2d0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ae2d0c",
  null
  
)

export default component.exports